export const FIELD_TYPES = {
    color: 'color',
    text: 'text',
    image: 'img'
}

export const getTemplateKey = (fieldKey, field) => `${fieldKey}_${field}`; 